module.exports = __webpack_public_path__ + "static/media/edit.edf542de.svg";